export function removeMarkerFromMap(
  marker: google.maps.marker.AdvancedMarkerElement
) {
  if (!marker) {
    return;
  }

  marker.map = null;
}
